import React from 'react';

const DecorativeElements = () => {
  return (
    <div className="stars">
      {[...Array(20)].map((_, i) => (
        <div
          key={i}
          className="star float"
          style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 3}s`,
            opacity: Math.random() * 0.5 + 0.3
          }}
        />
      ))}
      {[...Array(5)].map((_, i) => (
        <div
          key={`cloud-${i}`}
          className="cloud"
          style={{
            left: `${Math.random() * 90}%`,
            top: `${Math.random() * 60}%`,
            width: `${100 + Math.random() * 50}px`,
            height: `${40 + Math.random() * 20}px`
          }}
        />
      ))}
    </div>
  );
};

export default DecorativeElements;
